import React from 'react'
import utils from '../utils/utils'
import { Tooltip } from 'react-lightweight-tooltip'

const tooltipStyle = {
  wrapper: {
    cursor: 'pointer',
  },
  tooltip: {
    left: '120%'
  },
  gap: {
    height: '100px',
  }
}
export default class JobDetails extends React.Component {
  constructor(props, context){
    super(props, context)
  }
  render(){
    const items = this.props.job.workflkows
    const rows = items.map((item) => {
      let style = (item.status === 'DONE') ? 'success' : (item.status === 'ERROR') ? 'danger' : (item.status === 'STARTED') ? 'warning' : ''
      let errorLog = (item.status === 'ERROR') ?
        <Tooltip content={`${item.error.details || 'Unknown'}`} styles={tooltipStyle}>
          {item.status} <span className="glyphicon glyphicon-eye-open" aria-hidden="true"> </span>
        </Tooltip> :
        item.status
      return (
      <tr key = {item.workflow_id}>
        <td className={style}>{errorLog}</td>
        <td>{item.workflow_type}</td>
        <td>{item.workflow_id}</td>
        <td>{(item.end_time && item.start_time) ? utils.getFormatedDuration(new Date(item.end_time).getTime() - new Date(item.start_time).getTime()) : '----'}</td>
        <td>{item.details}</td>
        <td>{item.start_time}</td>
        <td>{item.end_time}</td>
      </tr> )
    })
    return(
      <div>
      <div className='row'>
        <div className='col-md-3'><label>Job ID: {this.props.job.id}</label></div>
        <div className='col-md-3'><label>Account: {this.props.job.account_id}</label></div>
        <div className='col-md-3'> <label>Media ID: {this.props.job.media_id}</label></div>
        <div className='col-md-2'><label>Duration: {this.props.job.total_time}</label></div>
      </div>
      <table className="table table-hover table-bordered mt5">
        <thead>
          <tr>
            <th>Status</th>
            <th>Workflow Type</th>
            <th>Workflow ID</th>
            <th>Duration</th>
            <th>Details</th>
            <th>Start</th>
            <th>End</th>
          </tr>
        </thead>
        <tbody>
          {rows}
        </tbody>
      </table>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/JobDetails.js